import React, { Fragment } from 'react';
import { PercentLabel } from '../Labels';
import { Tooltip } from '../../Tooltip';
import { StyledPercentChange, PercentChangeLabel } from './partials';
export var PercentChange = function PercentChange(_ref) {
  var change = _ref.change,
    label = _ref.label,
    tooltip = _ref.tooltip;
  return tooltip ? React.createElement(StyledPercentChange, null, React.createElement(Tooltip, {
    tip: tooltip.tip,
    from: tooltip.from ? tooltip.from : null
  }, React.createElement(PercentLabel, {
    bold: true,
    value: change,
    decimals: 2,
    withSparkline: true
  }), React.createElement(PercentChangeLabel, null, " ", label))) : React.createElement(Fragment, null, React.createElement(StyledPercentChange, null, React.createElement(PercentLabel, {
    bold: true,
    value: change,
    decimals: 2,
    withSparkline: true
  }), React.createElement(PercentChangeLabel, null, " ", label)));
};